<template>
  <div class="new-detail-contents" :class="duration_silence?'putash-s':''">
    <AccountInfo place="info-rigth" :keepalives="true"></AccountInfo>
    <div class="heard-nav">
      <div class="center1200">
        <img src="../assets/home/logo.png" height="56" width="290" style="margin-top: 23px"/>
        <div class="nav-list">
          <a href="#one" :class="navon=='one'?'on':''" @click="clicknav('one')">首页</a>
          <a href="#xzzs" :class="navon=='xzzs'?'on':''" @click="clicknav('xzzs')">新智造应用</a>
          <a href="#jjfas" :class="navon=='jjfas'?'on':''" @click="clicknav('jjfas')">应用场景</a>
          <a href="#xwzx" :class="navon=='xwzx'?'on':''" @click="clicknav('xwzx')">新闻动态</a>
          <a href="/knowledge-center">行业知识中心</a>
          <a href="#xqhz" :class="navon=='xqhz'?'on':''" @click="clicknav('xqhz')">校企合作</a>
          <a href="#about" :class="navon=='about'?'on':''" @click="clicknav('about')">关于我们</a>
          <a href="/HomePage">进入产业大脑</a>
        </div>
      </div>
    </div>
    <div style="height: 100px" id="one"></div>
    <div class="banner">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(item,index) in dataimg" :key="index"><img :src="item.url"><span class="buttons"><a :href="index==0?'/hxzl':'/login'" target="_blank">业务咨询</a><a :href="index==0?'/hxzl':'/register'" target="_blank">留言咨询</a></span></swiper-slide>
        <div class="swiper-button-next swiper-button-white" slot="button-prev">‹</div>
        <div class="swiper-button-prev swiper-button-white" slot="button-next">›</div>
      </swiper>
    </div>
    <div class="new-block">
      <a class="transform-show" :class='times==index?"transform-show-on":""' v-for="(itme,index) in datas" :key="index" :href="'/newdetail?id='+itme.id" target="_blank">
        <span>产业信息：</span><p class="new-block-c">{{ itme.title }}</p>
      </a>
    </div>
    <div class="xzz" id="xzzs">
      <div class="center1200">
        <h2 class="xzz-title">新智造应用</h2>
        <div class="xzz-content">
          <div :class="ischoose==0?'on':''" @click="getchoosexzz(0)"><span><i class="iconfont icon-gongyinglian"></i></span><p>供应链经营</p></div>
          <div :class="ischoose==1?'on':''" @click="getchoosexzz(1)"><span><i class="iconfont icon-shengchan"></i></span><p>生产控制</p></div>
          <div :class="ischoose==2?'on':''" @click="getchoosexzz(2)"><span><i class="iconfont icon-shebeiguanli1"></i></span><p>设备管理</p></div>
          <div :class="ischoose==3?'on':''" @click="getchoosexzz(3)"><span><i class="iconfont icon-anquanhuanbao"></i></span><p>安全环保</p></div>
          <div :class="ischoose==4?'on':''" @click="getchoosexzz(4)"><span><i class="iconfont icon-zhiliangguanli"></i></span><p>质量管理</p></div>
        </div>
      </div>
      <div class="xzz-main">
        <div class="center1200">
          <ul class="xzz-yy">
            <li v-for="(item,index) in xzzdata" :key="index"><div v-if="item.name" @click="gotonewsmartdetail(item.id)">{{item.name}} <em class="right-arrow"></em><em class="right-arrow"></em></div></li>
          </ul>
        </div>
      </div>
      <div class="cbsj" style="position: relative;z-index: 3">
        <h2 class="cbsj-title">{{ new Date().getFullYear() }}年数据看板</h2>
        <div class="center1200">
          <div class="cbsj-content">
            <div>
              <i class="iconfont icon-channeng"></i>
              <font><h4>化纤产能</h4><p><em style="width: 80px"><countTo :startVal='4250' :endVal='7523' :duration='8000'></countTo></em>+万吨</p></font>
            </div>
            <div>
              <i class="iconfont icon-shebeiguanli"></i>
              <font><h4>设备接入</h4><p><em style="width: 100px"><countTo :startVal='35600' :endVal='40000' :duration='8000'></countTo></em>台</p></font>
            </div>
            <div>
              <i class="iconfont icon-qiye"></i>
              <font><h4>接入企业</h4><p><em style="width: 80px"><countTo :startVal='2000' :endVal='4125' :duration='8000'></countTo></em>家</p></font>
            </div>
            <div>
              <i class="iconfont icon-jianpai"></i>
              <font><h4>3年内减排</h4><p><em style="width: 48px"><countTo :startVal='100' :endVal='250' :duration='10000'></countTo></em>+万吨</p></font>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="jjfa" id="jjfas">
      <img src="../assets/home/yycj.png" height="860" width="1920"/>
      <div id="xwzx">
        <div class="center1200" style="width: 1300px">
          <h2>···<span>新闻资讯</span>···</h2>
          <ul>
            <li v-for="(itme,index) in datas.slice(0,3)" :key="index">
              <el-image :src="itme.imageurl" fit="fit" style="width: 370px; height: 221px"></el-image>
              <div>
                <span>{{itme.auth}} | {{itme.createtime}}</span>
                <h3>{{itme.title}}</h3>
                <p>{{itme.content|toText}}</p>
                <a :href="'/newdetail?id='+itme.id" target="_blank">查看详情</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
<!--      <img src="../assets/home/xwzx.png" height="528" width="1284" id="xwzx"/>-->
    </div>
    <div class="xqhz" id="xqhz" style="height: 730px">
      <img src="../assets/home/xqhz.jpg" height="730" width="1920" style="display: inline-block"/></div>
    <div class="about" id="about">
      <div class="center1200">
        <h2 class="about-title">关于我们</h2>
        <div class="contact-us"><em></em><span>联系电话 15968181929</span><span>联系邮箱 yg@cfbrain.cn</span><em></em></div>
        <div class="about-c">
          <img src="../assets/home/hr.jpg" width="221" height="323">
          <div>
            <p>化学纤维产业大脑是贯彻落实省委省政府关于数字化改革的重要决策部署，加快推进以“产业大脑+未 来工厂”为核心架构的数字经济系统建设的重大工程。</p>
            <p>公司成立以后逐渐形成良性循环，通过为客户画像确立商业模式实现自我造血机制，同时作为化纤行业一个平台型的孵化器，不断拓展创新业务场景，吸纳优势资产，改造提升推动优势资产上市，实现自身的价值提升。萧山区是全球最大的化纤产业基地，近年来，萧山把数字化智能化改造作为推动化纤行业改造提升的首位度任务，从“点”向“面”拓展，成效显著，2017年以来，萧山相继被列入化纤纺织省级传统产业改造提升试点、省两化深度融合国家示范区、省振兴实体经济试点区、省制造业高质量发展示范区、省数字经济创新发展试验区等重大改革试点示范，两化融合指数连续四年位居全省第三。同时，萧山化纤产业链完整、企业集群集聚、数字化水平领先、需求和应用市场广泛，基本具备建设化纤行业产业大脑的基本条件</p>
            <p>立足“产业赋能”的价值导向，凸显产业服务公益属性，以“技术支撑+数据运营+应用服务”为核心业务，打造产业大脑赋能生态，为企业生产经营提供数字化赋能，为产业生态建设提供数字化服务，为经济治理提供数字化手段。</p>
          </div>
        </div>
      </div>
<!--      <img src="../assets/home/about.png" height="749" width="1920"/>-->
    </div>
    <span  class="for-record">
      © {{ new Date().getFullYear() }} 浙江萧山化学纤维产业大脑有限公司版权所有&nbsp;&nbsp;v<font>{{version}}</font> &nbsp;&nbsp; </br>备案号：<a href="http://beian.miit.gov.cn/" target="_blank"> {{ recordicp }} </a><img
      src="../assets/home/ba.png" height="22" width="20" style="vertical-align: sub; margin-left: 12px"/><a :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+recordpublic" rel="noopener" target="_blank"> 公网备案：{{ recordpublic }}</a>
      </span>
  </div>
</template>
<script>
import AccountInfo from './layout/account-info';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import countTo from 'vue-count-to';
export default {
  name: 'Home',
  components: {
    AccountInfo,
    swiper,
    swiperSlide,
    countTo
  },
  filters: {
    toText(vals) {
      let text =vals||''
      return text.toString().replace(/<[^<>]+>/g,'').replace(/\s*/g,"").replace(/(&nbsp;)/g,'').replace(/&([^&;]+);/g, function (matchStr, b) {
        var entity = {
          nbsp: ' ',
          quot: '"',
          lt: '<',
          gt: '>',
          apos: "'",
          amp: '&',
          ldquo: '“',
          rdquo: '”'
        };
        var r = entity[b];
        return typeof r === 'string' ? r : matchStr;
      })
    }
  },
  data () {
    return {
      dataimg:[
        {url:require('../assets/home/banner7.jpg')},
        {url:require('../assets/home/banner6.jpg')},
        // {url:require('../assets/home/banner3.jpg')},
        // {url:require('../assets/home/banner4.jpg')},
        // {url:require('../assets/home/banner4.jpg')}
        {url:require('../assets/home/banner5.jpg')}
      ],
      swiperOption: {//swiper3
        autoplay: 3500,
        speed: 1000,
        loop: true,
        autoplayDisableOnInteraction : false,
        nextButton: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
        prevButton: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
      },
      navon:'one',
      times:0,
      ischoose:0,
      version:this.$versionclient,
      datas:[
        {name:'华瑞信息资深分析师受邀在『化纤行业“高质量发展”实务能力培训班』做主题分享！',types:'行业资讯',url:'/newdetail?id=15'},
        {name:'1、安置自主择业军转干部人数占企业总人数60%以上的新办企业，经批准，3年内免征营业税和企业所得税。',types:'惠企政策',url:'/newdetail?id=1'},
        {name:'区委书记张冲林赴杭州招商引资',types:'招商引资',url:'/newdetail?id=2'},
        {name:'为绿色低碳企业腾飞插上翅膀',types:'行业资讯',url:'/newdetail?id=3'},
        {name:'《信息化建设》|“浙”样加快推进“未来工厂”建设',types:'行业资讯',url:'/newdetail?id=4'},
        {name:'袁家军：唯实惟先 整体提升 加快打造数字变革高地',types:'行业资讯',url:'/newdetail?id=5'},
        {name:'浙江省2022年数字工厂标杆企业认定类和培育类名单公布',types:'行业资讯',url:'/newdetail?id=6'},
        {name:'探访绿色纤维领域的“小巨人”企业--汇隆新材',types:'行业资讯',url:'/newdetail?id=7'},
        {name:'聚焦深化数字政府建设，浙江召开专场发布会',types:'行业资讯',url:'/newdetail?id=8'},
        {name:'萧山率先推进产业数字化“三个全覆盖”，发布《萧山区制造业细分行业中小企业数字化改造扩面推进方案（2022-2024）》',types:'行业资讯',url:'/newdetail?id=14'}
      ],
      xzz:[
        [
          {name:'生产计划管理APP',id:1},
          {name:'KSP供应链管理平台',id:48},
          {name:'供应链服务平台',id:2},
          {name:'采购管理APP',id:3},
          {name:'甄云甄采云SRM解决方案',id:49},
          {name:'财商管理APP',id:null},
        ],
        [
          {name:'工业生产能效管控平台',id:61},
          {name:'智能装卸车管理APP',id:18},
          {name:'新核云生产流程管理软件',id:50},
          {name:'生产制造执行管理系统',id:51},
          {name:'可视化能源管理软件V1.0',id:52},
          {name:'云生产系统',id:53},
        ],
        [
          {name:'智能印染系统',id:62},
          {name:'设备管理APP',id:22},
          {name:'设备综合管理软件',id:23},
          {name:'C-5001大机组预测性维护APP',id:30},
          {name:'设备运行分析APP',id:null},
          {name:'设备故障诊断与预测APP',id:null},
        ],
        [
          {name:'安全生产预警预报APP',id:32},
          {name:'安全生产综合监管信息平台',id:54},
          {name:'安全工作管理APP',id:null},
          {name:'安全生产信息化管理平台',id:55},
          {name:'化工企业安全生产信息化管理平台',id:56},
          {name:'生态环境物联网AI监测监管系统',id:33},
        ],
        [
          {name:'HGCYBER MES 制造执行系统',id:58},
          {name:'西格数据数字化工厂系统软件',id:59},
          {name:'OrBit-MES企业制造执行系统',id:60},
          {name:'综合报表APP',id:null},
          {name:'综合展示APP',id:null},
          {name:'',id:1}
        ]
      ],
      xzzdata:[],
      duration_silence:false, //静默置灰页面
      recordicp:process.env.RECORD=='production'?'浙ICP备2022025995号':'浙ICP备2022025995号-2',
      recordpublic:process.env.RECORD=='production'?'33010902003449':'33010902003449'
    }
  },
  mounted () {
    let $this=this
    console.log('-------------------------process.env.NODE_ENV---------------------------')
    // console.log(global.NODE_ENV)
    console.log(process.env.RECORD)
    const url = '/api-portal/article/articleList';
    this.$api.post(url, {title:'',pageNum:1,pageSize:20}, (response) => {
      let datas=response.data||''
      if(datas.data){
        $this.datas=datas.data.records
      }
      $this.cutnew()
    },'json')
    this.getchoosexzz(0)
  },
  methods:{
    clicknav(name){
      this.navon=name
    },
    cutnew(){
      let $this=this;
      let tt=$this.times
      let h=$this.datas.length
      if(h>1){
        setInterval(function (){
          if(tt>=h-1){
            tt = -1
          }
          tt+=1
          $this.times=tt
        },4000)
      }
    },
    getchoosexzz(num){
      this.xzzdata=this.xzz[num]
      this.ischoose=num
    },
    gotonewsmartdetail(id){
      if(id){
        this.$router.push('/newsmartdetail?id='+id)
      }
    }
  }
}
</script>

<style scoped>
.new-detail-contents{
  width: 100%;
  background: #003BB5;
  overflow: auto;
  height: 100%;
  position: relative;
}

.putash-s{
  -webkit-filter : grayscale(100%);
  -moz-filter: grayscale(100%);
  -o-filter: grayscale(70%);
  filter: grayscale(90%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
}

.new-detail-contents::-webkit-scrollbar{
  display: none;
}

.new-detail-contents>img{
  width: 100%;
  display: inline-block;
}

.center1200{
  width: 1300px;
  margin: 0 auto;
  position: relative;
}

  .heard-nav{
    height: 100px;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
    background: rgba(0,59,181,.9);
  }

  .nav-list{
    font-size: 18px;
    display: inline-block;
    height: 100px;
    vertical-align: top;
    margin-left: 35px;
  }

.nav-list a{
  color: #fff;
  text-decoration: none;
  margin: 0 18px;
  line-height: 100px;
  position: relative;
}
.nav-list a:hover{
  font-weight: bold;
}
.nav-list a.on:before{
  content: "";
  position: absolute;
  width: 86%;
  height: 3px;
  background-color: #F2F5FB;
  display: block;
  bottom: -15px;
  left: 7%;
  box-shadow: 0 2px 2px rgba(0,0,0,.2);
  border-radius: 2px;
  transition-delay: .1s, 0s;
  transition-duration: .3s, .3s;
}

  .banner{
    width: 100%;
    /*height: 540px;*/
    height: 480px;
    position: relative;
    overflow: hidden;
  }

  .swiper-button-white{
    width: 60px;
    height: 60px;
    position: absolute;
    left: 45px;
    top:50%;
    margin-top: -30px;
    border: 3px solid #fff;
    border-radius: 50%;
    cursor: pointer;
    z-index: 999;
    display: none;
    font-size: 62px;
    text-align: center;
    line-height: 50px;
    box-shadow: 3px 5px 10px rgba(0,0,0,0.67);
    text-shadow: 3px 5px 4px rgba(0,0,0,0.67);
    color: #fff;
  }

  .swiper-button-white:hover{
    background: rgba(255,255,255,.3);
  }

  .banner:hover .swiper-button-white{
    display: block;
  }

  .swiper-button-prev{
    left:auto;
    right: 45px;
  }

  .xzz,.jjfa{
    position: relative;
    margin: 0;
    background: #fff;
  }

  .jjfa{
    width: 100%;
    background: #F6F9FF; /*url("../assets/home/jjfa-bg.jpg") no-repeat center/100%*/
    /*height: 1590px;*/
    padding-top: 172px;
  }
  .home-cn{
    position: absolute;
    left: 50%;
    bottom: -170px;
    margin-left: -607px;
    z-index: 5;
  }
  #xwzx{
    padding-top: 80px;
    margin-top: 80px;
    background: url("../assets/home/cb-bg.jpg") no-repeat center/150%;
    height: 630px;
  }

#xwzx h2{
  font-size: 36px;
  font-family: 微软雅黑;
  text-align: center;
  color: #fff;
}
#xwzx h2 span{
  text-shadow: 2px 4px 3px rgba(0,0,0,0.7);
}

#xwzx ul{
  margin-top: 64px;
  display: flex;
  justify-content: space-around;
}

#xwzx li{
  width: 410px;
  height: 440px;
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  box-shadow: 3px 5px 13px rgba(0,0,0,0.37);
}
#xwzx li span{
  font-size: 12px;
  color: #777;
  display: block;
  margin: 26px 0 14px 0;
}

#xwzx li h3{
  font-size: 17px;
  color: #333;
  font-style: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#xwzx li p{
  font-size: 15px;
  color: #868686;
  margin: 14px 0;
  line-height: 164%;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space:normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-all;
  -webkit-line-clamp: 2;
}

#xwzx li a{
  color: #308CEB;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
}

#xwzx li a:hover{
  color: #126AC2;
}

.about{
  position: relative;
  background: #EFEFEF;
  height: 690px;
}

.about-title{
  font-size: 32px;
  text-align: center;
  font-family: 微软雅黑;
  color: #222;
  padding-top: 70px;
  padding-bottom: 18px;
}

.contact-us{
  text-align: center;
  font-size: 11px;
}

.contact-us span{
  margin: 0 18px;
}

.contact-us em{
  height: 1px;
  width: 200px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  background: linear-gradient(to left,rgba(0,0,0,0),rgba(0,0,0,.8));
}

.contact-us em:before{
  content: "";
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: #444;
  display: block;
  bottom: -2px;
  left: 0;
  border-radius: 50%;
}

.contact-us em:first-child{
  background: linear-gradient(to left,rgba(0,0,0,.8),rgba(0,0,0,0));
}

.contact-us em:first-child:before{
  left: auto;
  right: 0;
}

.about-c{
  display: flex;
  justify-content: space-between;
  width: 1000px;
  margin: 0 auto;
  margin-top: 57px;
}

.about-c>div{
  margin-left: 47px;
}

.about-c p{
  font-size: 16px;
  line-height: 198%;
  text-indent: 2em;
}
  .for-record{
    display: block;
    background: #000;
    line-height: 160%;
    padding: 18px 0;
    font-size: 14px;
    color: #fff;
    width: 100%;
    text-align: center;
  }
.for-record a{
  color: #fff;
}
.for-record a:hover{
  color: blue;
}

.new-block{
  width: 1200px;
  height: 53px;
  /*border: 1px solid #2F86F0;*/
  background: #003BB5;
  margin: 0 auto;
  position: relative;
  /*position: absolute;*/
  /*bottom: 15px;*/
  /*left: 50%;*/
  /*margin-left: -405px;*/
  /*z-index: 23;*/
  color: #fff;
  font-size: 15px;
  font-family: 微软雅黑;
  overflow: hidden;
}

.new-block span{
  font-size: 18px;
}

.new-block-c{
  overflow: hidden;
  width: 1070px;
  height: 29px;
  line-height: 29px;
  padding: 5px;
  background: rgba(0,16,49,.4);
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.transform-show{
  position: absolute;
  color: #fff;
  padding: 0px 20px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 1s;
  z-index: 1;
  opacity: 0;
  display: flex;
  align-items:center;
  transform: translate(0,-100%);
  text-decoration: none;
}

.transform-show-on{
  opacity: 1;
  transform: translate(0%,0%);
}

  .xzz-title{
    text-align: center;
    font-size: 38px;
    color: #1379E5;
    font-family:微软雅黑;
    text-shadow: 2px 4px 3px rgba(0,0,0,0.15);
    padding: 62px 0 42px 0;
  }
  .xzz-content{
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
  }

.xzz-content>div{
  text-align: center;
  position: relative;
  cursor: pointer;
}
  .xzz-content span{
    width: 90px;
    height: 90px;
    display: inline-block;
    background: linear-gradient(to bottom right,#F3F4F7,#B9C7E6);
    border-radius: 50%;
    color: #3199F7;
    line-height: 90px;
  }

.xzz-content>div.on:after{
  content: '';
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 16px solid #F4F5F7;
}

.xzz-content>div:hover span{
  background: linear-gradient(to bottom right,#F3F4F7,#53CBFF);
}

.xzz-content>div:hover p{
  color: #3199F7;
}

.xzz-content>div.on span{
  background: linear-gradient(to bottom right,#53CBFF,#0C76E0);
  color: #fff;
}

.xzz-content span i{
  font-size: 38px;
}

.xzz-content>div.on span i{
  font-size: 42px;
}

.xzz-content p{
  font-size: 23px;
  color: #3A3A3A;
  font-weight: bold;
  line-height: 160%;
  margin: 18px 0 32px 0;
}

  .xzz-main{
    width: 100%;
    background: #F4F5F7;
    padding: 35px 0 50px 0;
  }

.xzz-yy{
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.xzz-yy li{
  flex-basis: 320px;
  margin: 20px;
}

.xzz-yy li>div{
  height: 65px;
  line-height: 65px;
  font-size: 19px;
  text-align: center;
  color: #1379E5;
  font-weight: bold;
  background: #fff;
  cursor: pointer;
  border: 1px solid #EBEBEB;
}

.xzz-yy li>div:hover{
  background: #E8F2FD;
  box-shadow: 2px 4px 3px rgba(0,0,0,0.15);
}

.xzz-yy li .right-arrow{
  border-color: #1379E5;
}

  .cbsj{
    background: url("../assets/home/cb-bg.jpg") no-repeat center/100%;
    height: 199px;
  }

  .cbsj-title{
    font-size: 30px;
    color: #fff;
    text-align: center;
    font-weight: bold;
    padding: 42px 0;
    letter-spacing:0.2em;
  }

  .cbsj-content{
    width: 100%;
    height: 200px;
    background: #FDFDFD;
    border-bottom: 1px solid #e1e1e1;
    box-shadow: 4px 7px 12px rgba(0,0,0,0.07);
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

.cbsj-content i{
  display: inline-block;
  vertical-align: middle;
  font-size: 48px;
  color: #1890FF;
}

.cbsj-content font{
  display: inline-block;
  vertical-align: middle;
  margin-left: 18px;
}

.cbsj-content h4{
  font-family:微软雅黑;
  font-weight: bold;
  font-size: 24px;
  line-height: 160%;
}
.cbsj-content p{
  font-size: 14px;
  color: #333;
}
.cbsj-content em{
    font-size: 36px;
  display: inline-block;
    color: #3199F7;
  font-weight: bold;
  font-style: normal;
  font-family: Bahnschrift;
  margin-right: 8px;
  line-height: 145%;
  }

.buttons{
  position: absolute;
  left: 50%;
  bottom: 80px;
  margin-left: -745px;
}

.buttons a{
  width: 219px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  cursor: pointer;
  border: 3px solid #fff;
  border-radius: 8px;
  display: inline-block;
  font-size: 32px;
  text-decoration: none;
  color: #fff;
  margin: 0 12px;
}

.buttons a:hover{
  background: rgba(255,255,255,.3);
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue